<template>
  <div class="main-hero" style="background-color: #fe818c">
    <b-container>
      <div>
        <div style="padding: 20px">
          <h3 style="margin-bottom: 10px;">
            <strong>Memories</strong>of You & Me
          </h3>
          <b-row v-if="!memorySubmitted">
            <b-col>
              <b-img
                v-if="formMemory.imgURL"
                :src="formMemory.imgURL"
                fluid
                style="object-fit: contain"
                :alt="`My Memory with Derriana`"
              />
              <image-upload
                v-else
                ref="image-upload"
                class="photo-upload-wrapper"
                :img-upload-idx="idx"
                img-upload-type="photo"
                :storage-path="storagePath"
                :max-image="1"
                :show-edit="false"
                :show-delete="true"
                text-drag="Click to upload or drag photo memory (.png, .jpg) here. "
                @img-uploaded-url="handlePhotoUploadedURL"
              />
            </b-col>
            <b-col>
              <b-form-group>
                <label-info
                  v-if="false"
                  id="form-name"
                  label-name="Your Name"
                  label-info=""
                />
                <b-form-input
                  v-model="formMemory.name"
                  type="text"
                  class="custom-input"
                  style="
                    border-radius:40px;
                    padding:20px;
                    background-color:#dcabb0;
                    border-color: #b2ac88;
                    "
                  placeholder="Your Name"
                />
              </b-form-group>
              <b-form-group>
                <label-info
                  v-if="false"
                  id="form-comment"
                  label-name="Comment"
                  label-info=""
                />

                <b-form-textarea
                  type="text"
                  v-model="formMemory.comment"
                  style="
                    border-radius:15px;
                    padding:20px;
                    background-color:#dcabb0;
                    border-color: #b2ac88;
                    "
                  rows="3"
                  max-rows="6"
                  placeholder="Derriana and I had the best time during this photo ..."
                />
              </b-form-group>
              <span class="error">
                <div v-for="(anError, i) in this.errors" :key="`err_${i}`">
                  {{ anError }}
                </div>
              </span>
              <b-form-group>
                <b-button
                  pill
                  class="btn btn-success float-right"
                  style="border: none; background-color: #b2ac88; padding: 10px;"
                  @click="handleAddMemoryClick"
                >
                  Add Memory
                </b-button>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-else>
            <b-row>
              <b-col>
                <b-img
                  v-if="formMemory.imgURL"
                  :src="formMemory.imgURL"
                  style="border-radius: 15px"
                  fluid
                  :alt="`My Memory with Derriana`"
                />
              </b-col>
              <b-col style="padding: 50px;">
                <h5>"{{ formMemory.comment }}"</h5>
                <p>A memory of {{ formMemory.name }}</p>
              </b-col>
            </b-row>
          </b-row>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import LabelInfo from "@/components/common/labelInfo";
import UploadImage from "@/mixins/UploadImage";
import VideoHandling from "@/mixins/VideoHandling";
import ImageUpload from "@/components/common/imageUpload";
import axios from "axios";

export default {
  name: "Home_Main_Row",
  mixins: [UploadImage, VideoHandling],
  created() {
    this.formReset();
  },
  mounted() {},
  components: {
    ImageUpload,
    LabelInfo
  },
  methods: {
    handlePhotoUploadedURL(idx, url) {
      this.formMemory.imgURL = url;
    },
    handleAddMemoryClick() {
      debugger;
      if (this.simpleValidate().length > 0) return;

      axios.get("https://api.ipify.org?format=json").then(res => {
        let ip = res.data.ip;
        this.$store
          .dispatch("user/submitMemory", {
            form: this.formMemory,
            ip
          })
          .then(res => {
            this.memorySubmitted = true;
          });
      });
    },
    simpleValidate() {
      this.errors = [];

      /* if (this.formMemory && !this.validateEmail(this.formMemory.email))
        this.errors.push("Please enter a valid email");*/

      if (
        (this.formMemory && !this.formMemory.name) ||
        this.formMemory.name.length === 0
      )
        this.errors.push("Please enter your name");

      if (
        (this.formMemory && !this.formMemory.comment) ||
        this.formMemory.comment.length === 0
      )
        this.errors.push("Comment is required");

      return this.errors;
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    formReset() {
      this.formMemory = null;
      this.formMemory = this.formDefault;
    },
    handleSubmitANewMemory() {
      this.formReset();
      this.memorySubmitted = false;
    }
  },
  data() {
    return {
      idx: 0,
      memorySubmitted: false,
      storagePath: "derriana_memories_imgs",
      formMemory: null,
      formDefault: {
        name: null,
        comment: null,
        imgURL: null
      },
      errors: []
    };
  }
};
</script>

<style lang="scss" scoped>
.single {
  max-width: 600px;
  width: 100%;
  // height: 134px;

  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 56px;
  line-height: 120%;
  /* or 67px */

  /* Body */

  color: #222222;
}
.coming-soon__text {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.main-hero {
  //background: url("../../assets/img/home/hero.svg") no-repeat center center;
  //background-size: cover;
  background-color: #fe828c;
  h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    line-height: 55px;
    color: #0d0d21;
    display: flex;
    column-gap: 15px;
    margin-bottom: 16px;
    span {
      font-style: normal;
      font-weight: bold;
      font-size: 20px;
      line-height: 27px;
      display: flex;
      align-items: center;
      color: #ffcc4d;
      margin-top: -5px;
    }
  }
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #f3f6f9;
    margin-bottom: 30px;
  }
  .input-memory {
    margin-top: 25px;
    display: flex;
    justify-content: center;
    column-gap: 8px;
    min-height: 50px;
    background-color: #b2ac88;
    border-radius: 15px;
    margin-bottom: 15px;
    & > div {
      width: 100%;
    }
    .error {
      display: inline-block;
      margin-bottom: 6px;
      font-size: 12px;
      margin-left: 10px;
      color: #fff;
    }
    .form-control {
      padding: 12px 27px;
      height: 40px;
      border-radius: 20px;
      border: 1px solid #fff;
      margin: 15px;
      &:focus {
        outline: none;
        border: 1px solid #fff;
      }
      &::-webkit-input-placeholder {
        /* Edge */
        font-size: 12px;
        line-height: 16px;
        color: #8d99a0;
      }

      &:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        font-size: 12px;
        line-height: 16px;
        color: #8d99a0;
      }

      ::placeholder {
        font-size: 12px;
        line-height: 16px;
        color: #8d99a0;
      }
    }
    .btn-success {
      background: #010610;
      border-radius: 32px;
      height: 40px;
      font-style: normal;
      font-weight: bold;
      font-size: 12px;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      padding: 12px 16px;
      min-width: 150px;
      &:after,
      &:before {
        content: none;
      }
    }
  }
  img {
    margin: 40px 0;
  }
}
@media (min-width: 992px) {
  .banner-img {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 25px;
  }
}
@media (max-width: 768px) {
  .coming-soon__text {
    margin-top: 24px;
  }
  .main-hero {
    padding: 44px 0;
    h3 {
      font-size: 24px;
    }
    .input-memory {
      display: grid;
      grid-template-columns: 1fr;
      justify-items: start;
      margin-bottom: 12px;
    }
    .single {
      display: contents;
      height: unset;
    }
  }
  .banner-img svg {
    height: 400px;
  }
}
@media (max-width: 640px) {
  .single {
    font-size: 32px;
  }
}
</style>
